import React, { useEffect, useState } from 'react';
import { Progress } from 'antd';

const ProgressBar = ({ setTimeUp, key, isVisible }) => {
    const [progress, setProgress] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        const savedSecond = parseInt(localStorage.getItem('selectedSecond')) || 4;
        const maxProgress = 101;
        const increment = maxProgress / (savedSecond * 90); // Adjust increment value for smoother animation

        let interval;

        const updateProgress = () => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + increment;
                const isProgressComplete = newProgress >= maxProgress;

                if (isProgressComplete) {
                    setIsComplete(true);
                    setTimeUp(true);
                    clearInterval(interval);
                }

                return isProgressComplete ? maxProgress : newProgress;
            });
        };

        if (isVisible) {
            interval = setInterval(updateProgress, 10); // Adjust interval duration for smoother animation

            setTimeout(() => {
                setIsComplete(true);
                clearInterval(interval);
            }, savedSecond * 1000);
        }

        return () => {
            clearInterval(interval);
        };
    }, [key, isVisible, setTimeUp]);

    return (
        <div style={{ position: 'absolute' }}>
            <Progress
                type="circle"
                percent={progress}
                width={10}
                strokeColor={isComplete ? '#ff570f' : '#ff570f'}
                trailColor="#f5f5f5"
                format={() => null}
            />
        </div>
    );
};

export default ProgressBar;
